import posthog from 'posthog-js'

const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN
const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST

if (apiKey && apiHost) {
  posthog.init(apiKey, {
    api_host: apiHost,
    capture_exceptions: true,
    custom_campaign_params: ['shared_by'],
    debug: false,
  })
  // Previews and production share one PostHog project; filter on deploy_env.
  posthog.register({
    deploy_env: import.meta.env.VITE_DEPLOY_ENV ?? 'development',
    app_version: import.meta.env.VITE_APP_VERSION ?? 'local',
  })
}

export default posthog
